// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"108":"f7e4829d","113":"90958d30"}[chunkId] + ".chunk.js";
};